import React from 'react';
import PropTypes from 'prop-types';
import ViewIcon from '../../images/corrcluster/view_icon_toolPalette.svg';
import BuildIcon from '../../images/corrcluster/build_icon_toolPalette.svg';
import { CAC_LEFT_PANEL_VIEW_LABEL, CAC_LEFT_PANEL_BUILD_LABEL } from './CacConstants';

function CacToolPalette(props) {
  const { selectedView, projectId, isViewDisable, handleViewSwitch } = props;
  return (
    <div className="sample-left-nav" data-test="CacToolPaletteComponent">
      <div className="listItems">
        <li
          className={`item_list ${selectedView === CAC_LEFT_PANEL_BUILD_LABEL ? 'selected' : ''}`}
          onClick={() => handleViewSwitch(CAC_LEFT_PANEL_BUILD_LABEL, projectId)}
        >
          <div>
            <img
              src={BuildIcon}
              className="icons"
              title="BUILD"
              alt="Build Icon"
            />
            <p>Build</p>
          </div>
        </li>
        <li
          className={`item_list ${selectedView === CAC_LEFT_PANEL_VIEW_LABEL ? 'selected' : ''} 
            ${isViewDisable ? 'view-disable' : ''}`}
          onClick={() => handleViewSwitch(CAC_LEFT_PANEL_VIEW_LABEL, projectId)}
        >
          <div>
            <img
              src={ViewIcon}
              className="icons"
              title="VIEW"
              alt="View Icon"
            />
            <p>View</p>
          </div>
        </li>
      </div>
    </div>
  );
}

CacToolPalette.propTypes = {
  selectedView: PropTypes.string,
  handleViewSwitch: PropTypes.func,
  isViewDisable: PropTypes.bool,
  projectId: PropTypes.number,
};

export default CacToolPalette;

